










import { Vue, Component } from 'vue-property-decorator';
import AddBase from './AddBase.vue';

@Component({ components: { AddBase } })
export default class AddPantalla extends Vue {}
